import { useCookie } from "#app";
const readCsrfCookie = (name) => useCookie(name, { readonly: true });
export default async function handleCsrfCookie(app, ctx, logger) {
  const config = app.$config.public.echo;
  if (config.authentication?.mode !== "cookie") {
    return;
  }
  const { authentication } = config;
  if (authentication.csrfCookie === void 0) {
    throw new Error(`'echo.authentication.csrfCookie' is not defined`);
  }
  let csrfToken = readCsrfCookie(authentication.csrfCookie);
  if (!csrfToken.value) {
    if (authentication.csrfEndpoint === void 0) {
      throw new Error(`'echo.authentication.csrfCookie' is not defined`);
    }
    await $fetch(authentication.csrfEndpoint, {
      baseURL: authentication.baseUrl,
      credentials: "include",
      retry: false
    });
    csrfToken = readCsrfCookie(authentication.csrfCookie);
  }
  if (!csrfToken.value) {
    logger.warn(`${authentication.csrfCookie} cookie is missing, unable to set ${authentication.csrfHeader} header`);
    return;
  }
  if (authentication.csrfHeader === void 0) {
    throw new Error(`'echo.authentication.csrfHeader' is not defined`);
  }
  ctx.options.headers.set(authentication.csrfHeader, csrfToken.value);
}
